import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { myProfile } from 'Redux/user-profile/selectors';
import { useGuidedPracticeProvider } from 'Context/GuidedPracticeProvider';

import { GuidedPracticeTutorialModal as BaseGuidedPracticeTutorialModal } from '../../Components/GuidedPracticeTutorialModal';

const LOCAL_STORAGE_KEY = 'guided_practice_tutorial_modal_users';

const GuidedPracticeTutorialModal = ({ user }) => {
  const { showGuidedPracticeTutorialModal, setShowGuidedPracticeTutorialModal } =
    useGuidedPracticeProvider();

  useEffect(() => {
    const users = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
    if (users.includes(user.id)) {
      return;
    }
    setShowGuidedPracticeTutorialModal(true);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify([...users, user.id]));
  }, [setShowGuidedPracticeTutorialModal, user.id]);

  return (
    <BaseGuidedPracticeTutorialModal
      open={showGuidedPracticeTutorialModal}
      onClose={() => setShowGuidedPracticeTutorialModal(false)}
    />
  );
};

GuidedPracticeTutorialModal.propTypes = {
  user: PropTypes.object.isRequired,
};

export default connect((state) => ({ user: myProfile(state) }), {})(GuidedPracticeTutorialModal);
